export type ProductLineKey =
  'qube' | 'xhibit' | 'sentinel' | 'holter' | 'abpm' | 'portfolio_general';

export interface ProductLine {
  key: ProductLineKey;
  label: string;
  displayOrder: number;
}

export const PRODUCT_LINES: readonly ProductLine[] = [
  { key: 'qube', label: 'Qube', displayOrder: 1 },
  { key: 'xhibit', label: 'Xhibit', displayOrder: 2 },
  { key: 'sentinel', label: 'Sentinel', displayOrder: 3 },
  { key: 'holter', label: 'Holter', displayOrder: 4 },
  { key: 'abpm', label: 'ABPM', displayOrder: 5 },
  { key: 'portfolio_general', label: 'Portfolio General', displayOrder: 6 },
] as const;

export const PRODUCT_LINE_KEYS: readonly ProductLineKey[] = PRODUCT_LINES.map((p) => p.key);

export const PRODUCT_LINE_TO_DEVICES: Readonly<Record<ProductLineKey, readonly string[]>> = {
  qube: ['Patient Monitor X10', 'Bedside Monitor Q4'],
  xhibit: ['Xhibit Central Station', 'Xhibit Telemetry Receiver'],
  sentinel: ['Sentinel V11 Cardiac Monitor', 'Cardiac Event Monitor'],
  holter: ['Holter Monitor'],
  abpm: ['Ambulatory Blood Pressure Monitor'],
  portfolio_general: [
    'Defibrillator D500',
    'Ventilator V200',
    'Pulse Oximetry Sensors',
    'Convenience Kits',
    'ECG Lead Cables',
    'Infusion Pump',
    'MRI Surface Coil',
    'Surgical Instrument',
    'Glucose Monitor',
    'Pacemaker',
    'Sensors & Probes',
  ],
} as const;

const DEVICE_TO_PRODUCT_LINE: ReadonlyMap<string, ProductLineKey> = (() => {
  const map = new Map<string, ProductLineKey>();
  for (const key of PRODUCT_LINE_KEYS) {
    for (const device of PRODUCT_LINE_TO_DEVICES[key]) {
      map.set(device, key);
    }
  }
  return map;
})();

export const isProductLineKey = (value: string): value is ProductLineKey =>
  (PRODUCT_LINE_KEYS as readonly string[]).includes(value);

export const getProductLineLabel = (key: string): string => {
  const found = PRODUCT_LINES.find((p) => p.key === key);
  return found ? found.label : key;
};

export const getProductLineForDevice = (device: string): ProductLineKey =>
  DEVICE_TO_PRODUCT_LINE.get(device) ?? 'portfolio_general';

export const getDevicesForProductLine = (key: ProductLineKey): readonly string[] =>
  PRODUCT_LINE_TO_DEVICES[key] ?? [];
